
namespace Gordic.Adm.WebControls {

    /**
     * AdmPoznamky
     * 
     * @author thazmuka
     * @since 484.1.0.0
     */
    export class AdmPoznamky {

        private parentElement: JQuery<HTMLElement>;
        private panelElement: JQuery<HTMLElement>;

        private sxs: string;
        private typ_obj: number;
        private gcontent: GContent;

        /**
         * vytvořit panel poznámky
         * @param a_content
         * @param a_sxs
         * @param a_typ_obj
         * @param sidebarElement
         */
        public create( a_content: GContent, a_sxs: string, a_typ_obj: number, sidebarElement?: JQuery<HTMLElement>): GSideBarPanelOptions {

        this.gcontent = a_content;
            this.sxs = a_sxs;
            this.typ_obj = a_typ_obj;

            if (sidebarElement == null) {
                this.panelElement = $("<div>");
            }
            else {
                this.panelElement = sidebarElement;
            }

            return {
                leaf: {
                    caption: "jres:32000144", //RC 32000144 : Poznámky
                },
                minWidth: 400,
                icon: "fa-sticky-note-o",
                id: "panelPoznamky",
                caption: "jres:32000144",	//RC 32000144 : Poznámky
                open: (ev, obj) => {
                    this.panelElement = $(ev.target);
                    this.createPoznamky();
                },
            };
        }

        private gnotepanel = new Gordic.GNotePanel();

        private createPoznamky() {

            $(this.panelElement).empty();

            // pokud je některý z identikatoru null, empty, undefined - vyskočí warning
            if (this.isNullEmptyUndefined(this.sxs) || this.isNullEmptyUndefined(this.typ_obj)) {
                var text = $("<div>").text("jres:32000150"); //RC 32000150 : Některý z identifikátorů poznámky není naplněn.
                this.gcontent.dialogs.alert("jres:32000149", text); //RC 32000149 : Upozornění
            } 
            else {
                this.gnotepanel.create(this.panelElement, this.parentElement, { sxs: this.sxs, typObj: this.typ_obj });
            }

        }

        private isNullEmptyUndefined(value: string | number) {
            var state = false;
            if (typeof value === "string") {
                // empty
                if (value === "") {
                    state = true;
                }
            }
            // null
            if (value === null) {
                state = true;
            }
            // undefined
            if (value === undefined) {
                state = true;
            }
            return state;
        }

    }

}

 